import React, { useRef, useState } from 'react';
import { Button, makeStyles, Icons } from '~/lib/bn-material-ui';
import AddBinDialog from './dialog';
import { useSirenEntity } from '~/utility/BinSentry-ui-utility';

const useStyles = makeStyles(({ components }) => {
  const overrides = components.MuiButton.styleOverrides;
  return {
    /**
     * Inject contained button styling here since parcels don't have access to
     * the mui theme (even though it's provided with ThemeProvider). It's likely
     * caused by an race condition on the parcel & react env initializations.
     */
    button: {
      ...overrides.root,
      ...overrides.sizeMedium,
      ...overrides.containedPrimary,
      cursor: 'pointer',
      margin: '0.5em 0.25em 0.5em 0',
    },
    icon: {
      width: '18px',
      height: '18px',
      justifyContent: 'center',
      alignItems: 'center',
    },
  };
});

export default function AddBinButton({ href, modernStyling = false }) {
  const styles = useStyles();
  const dialogContainer = useRef();
  const [show, setShow] = useState(false);
  const { entity: orgEntity } = useSirenEntity({ href: href });
  const { entity: binsEntity } = useSirenEntity({ href: orgEntity?.getSubEntityByRel('https://api.binsentry.com/rel/bins').href });

  return (
    <div>
      {binsEntity?.hasAction('add-bin') && (
        <Button
          className={styles.button}
          variant='contained'
          disableTouchRipple={!modernStyling}
          focusRipple={!modernStyling}
          startIcon={<Icons.Add className={styles.icon}/>}
          onClick={() => setShow(true)}
        >
          Add Bin
        </Button>
      )}

      <div ref={dialogContainer} />

      <AddBinDialog
        href={href}
        show={show}
        handleClose={() => setShow(false)}
      />
    </div>
  );
}
